import React from 'react';
import { 
  Activity,
  AlertCircle,
  PauseCircle,
  XCircle,
  Mic2,
  Bus,
  RefreshCcw,
  FolderGit2,
  HelpCircle
} from 'lucide-react';

export enum BandActivityStatus {
  ACTIVE = 'active',
  DORMANT = 'dormant',
  HIATUS = 'hiatus',
  DISBANDED = 'disbanded',
  RECORDING = 'recording',
  TOURING = 'touring',
  REFORMING = 'reforming',
  PROJECT = 'project',
  UNKNOWN = 'unknown'
}

interface StatusIconProps {
  status: BandActivityStatus;
  size?: number;
  className?: string;
}

const getStatusColor = (status: BandActivityStatus): string => {
  const colors: Record<BandActivityStatus, string> = {
    [BandActivityStatus.ACTIVE]: '#22c55e',     // Green
    [BandActivityStatus.DORMANT]: '#f59e0b',    // Amber
    [BandActivityStatus.HIATUS]: '#f59e0b',     // Amber
    [BandActivityStatus.DISBANDED]: '#ef4444',   // Red
    [BandActivityStatus.RECORDING]: '#3b82f6',   // Blue
    [BandActivityStatus.TOURING]: '#22c55e',     // Green
    [BandActivityStatus.REFORMING]: '#3b82f6',   // Blue
    [BandActivityStatus.PROJECT]: '#8b5cf6',     // Purple
    [BandActivityStatus.UNKNOWN]: '#6b7280',     // Gray
  };
  return colors[status];
};

const StatusIcon: React.FC<StatusIconProps> = ({ status, size = 24, className = '' }) => {
  const iconProps = {
    size,
    className,
    color: getStatusColor(status)
  };

  const Icon = (() => {
    switch (status) {
      case BandActivityStatus.ACTIVE:
        return Activity;
      case BandActivityStatus.DORMANT:
        return PauseCircle;
      case BandActivityStatus.HIATUS:
        return AlertCircle;
      case BandActivityStatus.DISBANDED:
        return XCircle;
      case BandActivityStatus.RECORDING:
        return Mic2;
      case BandActivityStatus.TOURING:
        return Bus;
      case BandActivityStatus.REFORMING:
        return RefreshCcw;
      case BandActivityStatus.PROJECT:
        return FolderGit2;
      case BandActivityStatus.UNKNOWN:
        return HelpCircle;
      default:
        return Activity;
    }
  })();

  return <Icon {...iconProps} />;
};

const BandStatusDisplay: React.FC<{
  status: BandActivityStatus;
  showLabel?: boolean;
  size?: number;
  className?: string;
}> = ({ status, showLabel = true, size = 24, className = '' }) => {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
      <StatusIcon status={status} size={size} className={className} />
      {showLabel && (
        <span style={{ color: getStatusColor(status) }}>
          {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
        </span>
      )}
    </span>
  );
};

export default BandStatusDisplay;